import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// "2016-04-01" を Date に通すと閲覧者のタイムゾーンで月がずれるため、文字列から直接取り出す
export function formatYearMonth(date: string | null) {
  if (!date) return "現在";
  const [year, month] = date.split("-").map(Number);
  return `${year}年${month}月`;
}

export function formatPeriod(period: { start: string; end: string | null }) {
  return `${formatYearMonth(period.start)} 〜 ${formatYearMonth(period.end)}`;
}

export function calculateAge(birthday: string, today = new Date()): string {
  const birthDate = new Date(birthday);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return `${age}歳`;
}
